/*
 * @Author: cc
 * @Date: 2019-12-08 21:59:07
 * @LastEditTime: 2021-01-20 11:58:50
 * @LastEditors: cc
 * @FilePath: \MCN_new\app\utils\trsUploadForXj\upload.js
 * @Description:石榴云视频上传组件
 */

angular.module('trsUploadForXjModule', []).directive('trsUploadXj', [
    '$q',
    '$http',
    'modalDialog',
    function ($q, $http, modalDialog) {
        // 事件
        var handler = {
            /*
             * success: 上传成功后的回调，每个文件上传成功后都会调用，回调参数是文件信息对象
             * delete: 删除，回调参数是被删除的文件id
             * progress: 进度，回调参数 {id, progress}
             * fail: 上传失败回调，返回文件信息对象
             * */
        };
        // var WebUploader;
        // var md5;
        // Runs during compile
        return {
            // name: '',
            // priority: 1,
            // terminal: true,
            scope: {
                uploader: '=',
                callback: '&',
                option: '='
            }, // {} = isolate, true = child, false/undefined = no change
            restrict: 'EA', // E = Element, A = Attribute, C = Class, M = Comment
            templateUrl: './utils/trsUploadForXj/upload.html',
            replace: true,
            link: function ($scope, iElm) {
                initStatus();
                forSpeed();

                /**
                 * [initStatus description]初始化状态
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        files: [], // 上传的文件集合
                        userId: '0211243A0D694FBC95A041C82E772EAB',
                        appCode: 'oss',
                        companyId: 'onair',
                        chunkSize: 5 * 1024 * 1024, // 分块大小
                        backEndUrl: 'https://ys-web.xjmty.com/upload/',
                        uniqueFileNameMap: {},
                        filemd5MarkMap: {},
                        upload: {}
                    };
                    $scope.status = {
                        Q_TYPE_DENIED: '请检查文件格式',
                        Q_EXCEED_SIZE_LIMIT: '请检查文件大小'
                    };
                    $scope.WebUploader = {}; // WebUploader实例
                    $scope.md5 = {}; // md5实例
                    $scope.WebUploader = angular.copy(window.WebUploader);
                    $scope.md5 = angular.copy(window.md5);
                    $scope.option.el = $scope.option.el || '#uploadContainer';
                    uploadInit($scope.option);
                    $scope.data.upload.on = function (event, cb) {
                        if (handler[event]) {
                            handler[event].callback.push(cb);
                        } else {
                            handler[event] = {
                                emit: function () {
                                    handler[event].callback.forEach(cb => cb(...arguments));
                                },
                                callback: [cb]
                            };
                        }
                    };
                    // require(['./bower_components/videoUploadForXj/md5.js'], function (WebUploaderInfo) {

                    //     require(['./bower_components/videoUploadForXj/webuploader.js'], function (md5Info) {

                    //     });
                    // });
                }
                $scope.$on('$destroy', function () {
                    if ($scope.WebUploader.Uploader) {
                        $scope.WebUploader.Uploader.unRegister('anonymous');
                    }
                });

                /**
                 * [forSpeed description]获取上传速度
                 * @return  {[type]}  [return description]
                 */
                function forSpeed() {
                    $scope.data.timeMap = {};
                    $scope.data.sizeMap = {};
                    $scope.data.otimeMap = {};
                    $scope.data.ospeedMap = {};
                }

                /**
                 * [uploader description]上传单元
                 * @return  {[obj]}  [return description]上传实例
                 */
                $scope.uploader = function () {
                    handler = {};
                    setTimeout(function () {
                        $(iElm[0]).find('label').click();
                    }, 50);
                    $scope.data.upload.files = [];
                    return $scope.data.upload;
                };

                /**
                 * [httpServer description]
                 * @param   {[type]}  method  [method description]
                 * @param   {[type]}  url     [url description]
                 * @param   {[type]}  params  [params description]
                 * @return  {[type]}          [return description]
                 */
                function httpServer(method, url, params) {
                    var defer = $q.defer();
                    $http({
                        method: method,
                        url: url,
                        // headers: headers,
                        data: params
                    }).then(function (data) {
                        defer.resolve(data.data);
                    }, function (error) {
                        defer.reject(error);
                    });
                    return defer.promise;
                }

                /**
                 * [uploadInit description]上传初始化
                 * @param   {[type]}  options  [options description]上传配置项
                 * @return  {[type]}           [return description]
                 */
                function uploadInit(options) {
                    var checkType = 0;

                    /** ***********wu上传初始****************/
                    // eslint-disable-next-line no-new
                    new $scope.WebUploader.Uploader.register(
                        {
                            'before-send-file': 'beforeSendFile',
                            'before-send': 'beforeSend',
                            'after-send-file': 'afterSendFile'
                        },
                        {
                            // 上传文件开始触发
                            beforeSendFile: function (file) {
                                var task = new $.Deferred();
                                // 秒传验证
                                var md5Mark;
                                if (checkType == 1) {
                                    $scope.data.upload
                                        .md5File(file)
                                        .progress(function (percentage) { })
                                        .then(function (val) {
                                            md5Mark = val;
                                            $scope.data.filemd5MarkMap[file.id] = md5Mark;
                                            var params = {
                                                status: 'md5Check',
                                                md5: val
                                            };
                                            httpServer('post', $scope.data.backEndUrl + 'fileUploadCheck', params).then(
                                                function (data) {
                                                    var time = new Date().getTime();
                                                    $scope.data.timeMap[file.id] = time;
                                                    if (data.ifExist) {
                                                        // 若存在，这返回失败给WebUploader，表明该文件不需要上传
                                                        task.reject();
                                                        $scope.data.upload.skipFile(file);
                                                        file.path = data.path;
                                                        UploadComlate(file, $scope.data.filemd5MarkMap[file.id]);
                                                    } else {
                                                        task.resolve();
                                                    }
                                                },
                                                function (error) {
                                                    task.resolve();
                                                }
                                            );
                                        });
                                } else {
                                    $scope.data.sizeMap[file.id] = 0;
                                    $scope.data.otimeMap[file.id] = 0;
                                    task.resolve();
                                }
                                return $.when(task);
                            },
                            // 开始上传分片触发
                            beforeSend: function (block) {
                                // 分片验证是否已传过，用于断点续传
                                // var defer = $q.defer();
                                var task = new $.Deferred();
                                var file = block.file;
                                var id = file.id;
                                $scope.data.upload.md5File(file, block.start, block.end).then(function (val) {
                                    var params = {
                                        status: 'chunkCheck',
                                        name: $scope.data.uniqueFileNameMap[id],
                                        chunkIndex: block.chunk,
                                        size: block.end - block.start,
                                        userId: $scope.data.userId,
                                        companyId: $scope.data.companyId,
                                        appCode: $scope.data.appCode,
                                        blockmd5: val
                                    };
                                    httpServer('post', $scope.data.backEndUrl + 'fileUploadCheck', params).then(
                                        function (data) {
                                            var time = new Date().getTime();
                                            $scope.data.timeMap[file.id] = time;
                                            if (data.ifExist == 1) {
                                                // 若存在，返回失败给WebUploader，表明该分块不需要上传
                                                task.reject();
                                            } else {
                                                task.resolve();
                                                // defer.resolve();
                                            }
                                        },
                                        function (error) {
                                            task.reject();
                                        }
                                    );
                                });
                                // return defer.promise;
                                return $.when(task);
                            },
                            // 上传文件完成触发
                            afterSendFile: function (file) {
                                var defer = $q.defer();
                                var chunksTotal = Math.ceil(file.size / $scope.data.chunkSize);
                                // 合并请求
                                var params = {
                                    status: 'chunksMerge',
                                    name: $scope.data.uniqueFileNameMap[file.id],
                                    chunks: chunksTotal,
                                    ext: file.ext,
                                    md5: $scope.data.filemd5MarkMap[file.id],
                                    userId: $scope.data.userId,
                                    companyId: $scope.data.companyId,
                                    appCode: $scope.data.appCode
                                };
                                httpServer('post', $scope.data.backEndUrl + 'fileUploadCheck', params).then(
                                    function (data) {
                                        var status = data.status;
                                        file.path = data.path;
                                        defer.resolve();
                                        if (status == 1) {
                                            UploadComlate(file, $scope.data.filemd5MarkMap[file.id]);
                                        } else {
                                            UploadFail(file);
                                        }
                                        delete $scope.data.uniqueFileNameMap[file.id];
                                        delete $scope.data.filemd5MarkMap[file.id];
                                    },
                                    function (error) {
                                        defer.reject(error);
                                    }
                                );
                                return defer.promise;
                            }
                        }
                    );

                    /** *********上传配置*********************/
                    var opt = $.extend(
                        {
                            swf: 'js/Uploader.swf', // 上传的flash
                            server: $scope.data.backEndUrl + 'fileUpload', // 后台上传方法,
                            pick: {
                                id: jQuery(options.el)[0],
                                multiple: options.multiple
                            },
                            resize: false,
                            dnd: '',
                            disableWidgets: 'log',
                            paste: document.body,
                            disableGlobalDnd: true,
                            thumb: {
                                width: 100,
                                height: 100,
                                quality: 100,
                                allowMagnify: false,
                                crop: true
                            },
                            compress: false,
                            prepareNextFile: true,
                            chunked: true,
                            chunkSize: $scope.data.chunkSize,
                            threads: '5',
                            formData: {
                                userId: $scope.data.userId,
                                appCode: $scope.data.appCode,
                                companyId: $scope.data.companyId
                            },
                            // fileSizeLimit: 100 * 1024 * 1024 * 1024,
                            fileSingleSizeLimit: 100 * 1024 * 1024 * 1024,
                            duplicate: true,
                            auto: true,
                            accept: {}
                        },
                        options || {}
                    );
                    $scope.data.upload = $scope.WebUploader.create(opt);

                    /** **********文件加入上传加入队列前执行*******************/
                    $scope.data.upload.on('beforeFileQueued', function (file) {
                        if (file.size > $scope.option.fileSingleSizeLimit) {
                            modalDialog.alertType('上传失败', '请上传300MB以下的文件', 'error', false);
                            return false;
                        }
                        handler.beforeFileQueued &&
                            handler.beforeFileQueued.emit({
                                file: file,
                                uploadObj: $scope.data.upload
                            });
                        // 判断是不是通过上传前验证
                        if (file.isCheck === true) {
                            return false;
                        }
                    });

                    /** **********文件加入上传队列执行*******************/
                    $scope.data.upload.on('fileQueued', function (file) {
                        $scope.data.upload.sort(function (a, b) {
                            return a.size - b.size;
                        }); // 多文件同时加入时小文件优先上传
                        $scope.data.ospeedMap[file.id] = 0;
                        var uniqueFileName = $scope.md5(file.name + file.size + file.type + $scope.data.userId); // 文件唯一标识
                        $scope.data.uniqueFileNameMap[file.id] = uniqueFileName;
                        $scope.data.upload.files.push(file);
                        handler.queued &&
                            handler.queued.emit({
                                file: file,
                                uploadObj: $scope.data.upload
                            });
                    });

                    /** *********上传进度获取**************/
                    $scope.data.upload.on('uploadProgress', function (file, percentage, uploaded) {
                        var num = percentage * 100;
                        var index = $scope.data.upload.files.indexOf(file);
                        var osize = $scope.data.sizeMap[file.id]; // 前大小
                        var size = file.size * percentage; // 现大小
                        $scope.data.sizeMap[file.id] = size;
                        var sizesp = file.size - size; // 剩余大小
                        var sizedf = size - osize; // 大小差
                        var otime = $scope.data.timeMap[file.id]; // 前时间
                        var time = new Date().getTime(); // 现时间
                        $scope.data.timeMap[file.id] = time;
                        var timedf = (time - otime) / 1000;
                        var timesp = 0;
                        var speed = $scope.data.ospeedMap[file.id];
                        if (timedf > 0.068 && timedf < 0.088 && sizedf != 0) {
                            speed = Math.round(sizedf / timedf / 1024);
                            $scope.data.ospeedMap[file.id] = speed;
                        }
                        if (speed != 0) {
                            timesp = Math.round(sizesp / speed / 1000);
                        }
                        $scope.data.upload.files[index].percentage = num.toFixed(2) + '%';
                        handler.progress &&
                            handler.progress.emit({
                                uploadObj: $scope.data.upload,
                                file: file,
                                id: file.id,
                                progress: num,
                                speed: formatSpeed(speed * 1000),
                                time: formatSeconds(timesp)
                            });
                    });

                    /** ***********上传失败回调************/
                    $scope.data.upload.on('error', function (type) {
                        modalDialog.alertType('上传失败', $scope.status[type], 'error', false);
                    });

                    /**
                     * [UploadComlate description] 上传成功触发
                     * @param   {[object]}  file  [file description] 文件对象
                     * @return  {[type]}          [return description]
                     */
                    function UploadComlate(file) {
                        delete $scope.data.timeMap[file.id];
                        delete $scope.data.sizeMap[file.id];
                        delete $scope.data.ospeedMap[file.id];
                        delete $scope.data.otimeMap[file.id];
                        handler.success && handler.success.emit(file);
                    }

                    /**
                     * [UploadFail description] 上传失败触发
                     * @param   {[object]}  file  [file description] 文件对象
                     * @return  {[type]}          [return description]
                     */
                    function UploadFail(file) {
                        // 上传失败
                        delete $scope.data.timeMap[file.id];
                        delete $scope.data.sizeMap[file.id];
                        delete $scope.data.ospeedMap[file.id];
                        delete $scope.data.otimeMap[file.id];
                        modalDialog.alertType('上传失败', '请重新上传', 'error', false);
                        handler.fail && handler.fail.emit(file);
                    }
                    $(function () {
                        $(document).on({
                            dragleave: function () {
                                // 拖离
                                $('#uploadArea').removeClass('hover');
                            },
                            drop: function () {
                                // 拖后放
                                $('#uploadArea').addClass('hover');
                            },
                            dragenter: function () {
                                // 拖进
                                $('#uploadArea').addClass('hover');
                            },
                            dragover: function () {
                                // 拖来拖去
                                $('#uploadArea').addClass('hover');
                            }
                        });
                    });

                    /** *************弹窗控制***********************/
                }

                /**
                 * [close description]弹窗关闭
                 * @return  {[type]}  [return description]
                 */
                $scope.close = function () {
                    $scope.option.showModal = false;
                    handler.close && handler.close.emit();
                };

                /**
                 * [deleteFile description]删除文件
                 * @param   {[obj]}  file        [file description]文件对象
                 * @return  {[undefined]}        [return description]
                 */
                $scope.deleteFile = function (file) {
                    $scope.data.upload.files.splice($scope.data.upload.files.indexOf(file), 1);
                    delete $scope.data.uniqueFileNameMap[file.id];
                    delete $scope.data.filemd5MarkMap[file.id];
                    delete $scope.data.timeMap[file.id];
                    delete $scope.data.sizeMap[file.id];
                    delete $scope.data.ospeedMap[file.id];
                    delete $scope.data.otimeMap[file.id];
                    $scope.data.upload.removeFile(file.id, true); // 从上传文件列表中删除
                    // handler.delete && handler.delete.emit(id);
                    handler.delete && handler.delete.emit(file.id);
                };

                /**
                 * [reUpload description]重新上传
                 * @param   {[object]}  file     [file description]文件对象
                 * @return  {[undefined]}        [return description]
                 */
                $scope.reUpload = function (file) {
                    var uniqueFileName = $scope.md5(file.name + file.size + file.type + $scope.data.userId);
                    $scope.data.uniqueFileNameMap[file.id] = uniqueFileName;
                    $scope.data.upload.retry(file);
                };

                /**
                 * [formatSpeed description]获取上传速度
                 * @param   {[string]}  speed  [speed description]上传速度
                 * @return  {[string]}         [return description]上传速度
                 */
                function formatSpeed(speed) {
                    var standard = 0;
                    1024 <= Math.round(speed / 1024) ? ((standard = Math.round(100 * (speed / 1048576)) / 100), (standard = Math.max(0, standard)), (standard = isNaN(standard) ? 0 : parseFloat(standard).toFixed(2)), (speed = standard + 'MB/s')) : ((standard = Math.round(100 * (speed / 1024)) / 100), (standard = Math.max(0, standard)), (standard = isNaN(standard) ? 0 : parseFloat(standard).toFixed(2)), (speed = standard + 'KB/s'));
                    return speed;
                }

                /**
                 * [formatSeconds description]
                 * @param   {[type]}  time  [time description]
                 * @return  {[type]}        [return description]
                 */
                function formatSeconds(time) {
                    var total = time || 0,
                        hour = Math.floor(total / 3600),
                        minute = Math.floor((total - 3600 * hour) / 60),
                        second = Math.floor(total - 3600 * hour - 60 * minute),
                        hour = '' + (!isNaN(hour) && 0 < hour ? (hour < 10 ? '0' + hour + ':' : hour + ':') : '00:'),
                        hour = hour + (!isNaN(minute) && 0 < minute ? (minute < 10 ? '0' + minute + ':' : minute + ':') : '00:');
                    return (hour += !isNaN(second) && 0 < second ? (second < 10 ? '0' + second + '' : second) : '00');
                }
            }
        };
    }
]);
